import { init } from "@sentry/react";
import type { PropsWithChildren } from "react";
import { useEffect } from "react";

export function SentryProvider({ children }: PropsWithChildren) {
	useEffect(() => {
		if (typeof window !== "undefined" && import.meta.env.VITE_SENTRY_DNS) {
			init({
				dsn: import.meta.env.VITE_SENTRY_DNS,
				sendDefaultPii: true,
				environment: import.meta.env.MODE || "development",

				// Para SPA, você pode querer configurar:
				tracesSampleRate: 1.0, // Ajuste conforme necessário

				// Desabilita features que requerem servidor
				beforeSend(event) {
					// Filtra eventos se necessário
					return event;
				},
			});
		}
	}, []);

	return <>{children}</>;
}
